import { CHATROOM_TYPE } from '../../Chatroom.constants'

export function getChatroomMessageTypeOptions({ t }) {
  return [
    {
      id: CHATROOM_TYPE.Private,
      label: t('Chatroom.MessageTypePrivateOptionKey'),
    },
    {
      id: CHATROOM_TYPE.Public,
      label: t('Chatroom.MessageTypePublicOptionKey'),
    },
  ]
}

export function isPublicChatroomType(value) {
  return value === CHATROOM_TYPE.Public
}
